import Vue from 'vue'
import Axios from "axios"
import {getEncodeData} from "@/security/EncryptionUtil";

export default function install(vue) {
//配置全局的axios默认值（可选）
    Vue.prototype.$axios = Axios;

    Vue.prototype.$axios.postWithEncrypt = function (url, data, bodyEncrypt, config) {
        console.log("encrypt=============")
        if (data != null) {
            data = getEncodeData(data, bodyEncrypt)
        }
        return this.post(url, data, config)
    }
    Axios.defaults.baseURL = '/';
// 设置axios请求的token
    Axios.defaults.headers.post['Content-Type'] = 'application/json';
}



// WEBPACK FOOTER //
// ./src/plugins/AxiosPlugin.js